var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import { useUserSessionAPI } from '../components/app/selectors';
export var NotFound = function () {
  var _a = useUserSessionAPI(),
    fetchUserSessionData = _a[1];
  useEffect(function () {
    fetchUserSessionData();
  }, [fetchUserSessionData]);
  var t = useTranslation('translation').t;
  return _jsxs("article", __assign({
    style: {
      padding: '100px'
    }
  }, {
    children: [_jsx("h1", {
      children: t('notFound.opp')
    }), _jsx("p", {
      children: t('notFound.pageNotFound')
    }), _jsx("div", {
      children: _jsx(Link, __assign({
        to: "/"
      }, {
        children: t('notFound.backToHome')
      }))
    })]
  }));
};